import React from "react"
import NumerableIconButton from "../../NumerableIconButton"
import { JARGON, LAYOUT } from "../../../modules/constants"
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined"
import WebIcon from "@mui/icons-material/Web"

const website = "Company Website"

const getbuttonProps = ({ label, link, paddingLeft = LAYOUT.COLUMN_PADDING, paddingRight = LAYOUT.COLUMN_PADDING, page = null }) => ({
  disabled: !link,
  icon: <WebIcon />,
  label,
  handleClick: () => { window.open(link, "_blank") },
  paddingLeft,
  paddingRight,
  tipEnabled: `${JARGON.EXTERNAL_LINK_TO}${page ?? label} page on ${website}`,
  width: "",
  fontWeight: "normal",
})

// Prefix link with "https://" (blank/whitespace-only links are treated as absent)
const getLink = link => link?.trim() ? `https://${link.trim()}` : null

function WebsiteMenu(props) {
  // console.log('WebsiteMenu props:', props)

  const { externalLinks, hubData: { lseProps }, portrait } = props
  const homePage = getLink(lseProps?.websiteLinks?.home)
  const boardPage = getLink(lseProps?.websiteLinks?.board)
  const committeesPage = getLink(lseProps?.websiteLinks?.committees)

  const buttonProps = {

    homePage: getbuttonProps({
      link: homePage,
      label: website,
      paddingLeft: LAYOUT.MENU_FIRST_PADDING,
      page: "Home",
    }),
    boardPage: // props.features.Developer &&
      getbuttonProps({ link: boardPage, label: "Board" }),
    committeesPage: getbuttonProps({ link: committeesPage, label: "Committees" }),
    // payPage: getbuttonProps({ link: payPageLink, label: "Remuneration" }),
    // revPage: getbuttonProps({ link: revPageLink, label: "Income" }),
  }

  const tipEnabled = JARGON.EXTERNAL_LINK_TO + website
  const websiteButton = {
    disabled: !externalLinks && !homePage,
    tipEnabled,
    tipDisabled: tipEnabled + JARGON.SUBSCRIBED_USERS_ONLY,
    icon: <PublicOutlinedIcon />,
    label: website,
    handleClick: () => { window.open(homePage, "_blank") },
    fontWeight: "normal",
  }

  return (
    <div>
      {props.enableWebsite && homePage && boardPage &&
        <React.Fragment>
          <NumerableIconButton item={buttonProps.homePage} portrait={portrait} />
          <NumerableIconButton item={buttonProps.boardPage} portrait={portrait} />
          {committeesPage && <NumerableIconButton item={buttonProps.committeesPage} portrait={portrait} />}
        </React.Fragment>}

      {props.enableWebsite && homePage && !boardPage &&
        <React.Fragment>
          <NumerableIconButton item={websiteButton} portrait={portrait} />
          {committeesPage && <NumerableIconButton item={buttonProps.committeesPage} portrait={portrait} />}
        </React.Fragment>
      }

    </div >
  )
}

export default WebsiteMenu

